<template>
  <footer>
    <div class="container">
      <div class="inner">
        <div class="footer-col" v-if="JSON.parse(cta)">
          <site-button
            v-if="JSON.parse(cta)"
            :link="JSON.parse(cta)"
            :label="JSON.parse(cta).title"
            :colour="'#00ffa3'"
          ></site-button>
        </div>
        <div class="footer-col norm" :class="{ no_cta: !JSON.parse(cta) }">
          <ul class="footer-menu">
            <li
              v-for="(menu_item, index) in footerMenu2"
              :key="index"
              :class="{
                'has-children':
                  menu_item.children && menu_item.children.length > 0,
                selected: menu_item.object_id == currentId,
                tel: menu_item.url.includes('tel:'),
              }"
            >
              <a
                :href="localUrlSwap(menu_item['url'])"
                v-html="menu_item['title']"
              ></a>
              <ul>
                <li
                  v-for="(menu_item_sub, index) in menu_item['children']"
                  :key="index"
                >
                  <a
                    :href="localUrlSwap(menu_item_sub['url'])"
                    v-html="menu_item_sub['title']"
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="footer-col">
          <ul class="footer-menu">
            <li
              v-for="(menu_item, index) in footerMenu"
              :key="index"
              :class="{
                'has-children':
                  menu_item.children && menu_item.children.length > 0,
                selected: menu_item.object_id == currentId,
                tel: menu_item.url.includes('tel:'),
                'no-click': menu_item.classes[0] === 'no-click',
              }"
            >
              <a
                :href="localUrlSwap(menu_item['url'])"
                v-html="menu_item['title']"
              ></a>

              <ul>
                <li
                  v-for="(menu_item_sub, index) in menu_item['children']"
                  :key="index"
                >
                  <a
                    :href="localUrlSwap(menu_item_sub['url'])"
                    v-html="menu_item_sub['title']"
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="footer-col center">
          <a class="logo" href="/"><img :src="footerLogo" alt="CPMEC"/></a>

          <ul class="social">
            <li v-if="JSON.parse(facebook)">
              <a
                :href="JSON.parse(facebook).url"
                :target="JSON.parse(facebook).target"
                ><img :src="this.faceIcon" alt="Facebook"
              /></a>
            </li>
            <li v-if="JSON.parse(instagram)">
              <a
                :href="JSON.parse(instagram).url"
                :target="JSON.parse(instagram).url"
                ><img :src="this.instaIcon" alt="Instagram"
              /></a>
            </li>
          </ul>
        </div>

        <div class="footer-lower">
          <span>
            <p>
              &copy; CPMEC {{ getTheYear }}. All Rights Reserved. ACN 144 489
              038. ABN 49 144 489 038.
            </p>

            <ul class="footer-menu">
              <li
                v-for="(menu_item, index) in footerMenu3"
                :key="index"
                :class="{
                  'has-children':
                    menu_item.children && menu_item.children.length > 0,
                  selected: menu_item.object_id == currentId,
                  tel: menu_item.url.includes('tel:'),
                }"
              >
                <a
                  :href="localUrlSwap(menu_item['url'])"
                  v-html="menu_item['title']"
                ></a>

                <ul>
                  <li
                    v-for="(menu_item_sub, index) in menu_item['children']"
                    :key="index"
                  >
                    <a
                      :href="localUrlSwap(menu_item_sub['url'])"
                      v-html="menu_item_sub['title']"
                    ></a>
                  </li>
                </ul>
              </li>
            </ul>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';
import instagramIcon from '../../images/instagram.svg';
import facebookIcon from '../../images/facebook.svg';
import SiteButton from '../vue/SiteButton.vue';
import footerLogo from '../../images/logo-reverse.svg';

export default {
  data() {
    return {
      instaIcon: instagramIcon,
      faceIcon: facebookIcon,
      footerMenu: null,
      footerMenu2: null,
      footerMenu3: null,
      footerLogo: footerLogo,
    };
  },

  props: {
    altLogo: {},
    currentId: {
      type: Number,
      default: -1,
    },
    facebook: {
      default: '#',
    },
    instagram: {
      default: '#',
    },
    cta: {
      default: null,
    },
    disclaimer: {},
    privacy: {},
  },

  computed: {
    getTheYear() {
      var d = new Date();
      var n = d.getFullYear();
      return n;
    },

    parsedCta() {
      if (Array.isArray(this.cta)) {
        return this.cta;
      } else if (!Array.isArray(this.cta)) {
        return JSON.parse(this.cta);
      } else {
        return null;
      }
    },
  },

  watch: {},

  methods: {
    localUrlSwap(value) {
      if (window.location.host === 'localhost:3000') {
        return value.replace('cpmec.test', 'localhost:3000');
      } else {
        return value;
      }
    },
  },

  components: {
    SiteButton,
  },

  created() {},
  mounted() {
    axios
      .get('/wp-json/wp/v2/footer_menu')
      .then(response => (this.footerMenu = response.data));
    axios
      .get('/wp-json/wp/v2/footer_menu_2')
      .then(response => (this.footerMenu2 = response.data));
    axios
      .get('/wp-json/wp/v2/footer_menu_3')
      .then(response => (this.footerMenu3 = response.data));
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

footer {
  background: $cpmec-grey;
  width: 100%;
  margin: 0;
  padding: $spacer * 2 0;

  @media (max-width: $lg) {
    margin: 0 0;
    width: calc(100% - 40px);
    padding: $spacer $spacer;
  }

  .container {
    @media (max-width: $lg) {
      margin: 0 0;
      padding: $spacer 0;
    }
  }

  .inner {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 100%;
    row-gap: $spacer * 2;

    @media (max-width: $lg) {
      display: flex;
      flex-direction: column;
      row-gap: $spacer * 2;
    }

    .footer-col {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      row-gap: $spacer * 2;
      grid-column: span 1;
      padding-right: $spacer;
      align-items: flex-start;

      @media (max-width: $lg) {
        grid-column: 1;
        padding-right: 0;
        align-items: center;
      }

      &.center {
        justify-content: center;
        padding-right: 0;
        align-items: center;

        @media (max-width: $lg) {
          grid-column: span 1;
          flex-direction: column-reverse;
          row-gap: 0;

          .social {
            margin-bottom: $spacer * 2;
          }
        }
      }

      .footer-menu {
        flex-direction: column;
        margin-left: 0;
        column-gap: $spacer;

        @media (max-width: $lg) {
          width: 100%;
          flex-direction: column;
          margin: 0 auto;
          column-gap: 0;
          row-gap: $spacer / 2;
          align-items: center;
        }

        li {
          @media (max-width: $lg) {
            text-align: center;
          }

          a {
            font-size: $font-size-root;

            @media (max-width: $lg) {
              font-size: 18px;
            }
          }
        }
      }

      &.no_cta {
        grid-column: span 2;
      }
    }

    .footer-lower {
      grid-column: span 4;
      border-top: 1px solid var(--cpmec-grey-dark);
      padding-top: $spacer;
      color: $cpmec-white;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      @media (max-width: $lg) {
        grid-column: 1;
        flex-direction: column;
        padding-top: $spacer * 2;
      }

      > span {
        display: flex;
        flex-direction: row;

        @media (max-width: $lg) {
          flex-direction: column;
        }
      }

      p {
        color: $cpmec-white;
        margin: 0;

        @media (max-width: $lg) {
          margin-bottom: $spacer;
          font-size: 14px;
          text-align: center;
        }
      }

      a {
        font-size: $font-size-root;
        color: $cpmec-white;
        text-decoration: none;
        font-weight: normal;

        @media (max-width: $lg) {
          text-align: center;
          margin-top: $spacer;
          font-size: 14px;
        }
      }

      .footer-menu {
        flex-direction: row;
        margin-left: $spacer;
        column-gap: $spacer;

        @media (max-width: $lg) {
          width: 100%;
          flex-direction: row;
          margin: 0 auto;
          align-items: center;
        }

        li {
          color: $cpmec-white;
          @media (max-width: $lg) {
            text-align: center;
          }

          a {
            font-size: $font-size-root;

            @media (max-width: $lg) {
              font-size: 14px;
            }
          }
        }
      }
    }

    .logo {
      grid-column: span 1;
      display: flex;
      justify-content: center;

      img {
        // width: 265px;
        height: 40px;
        max-width: 100%;
        filter: grayscale(1);

        @media (max-width: $lg) {
          // width: 200px;
          height: 30px;
        }
      }
    }

    ul {
      order: 3;
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      column-gap: $spacer * 2;
      justify-content: center;
      align-items: flex-start;
      grid-column: span 2;
      row-gap: $spacer;

      &.footer-menu {
        column-gap: $spacer;
        row-gap: $spacer;

        li {
          color: $cpmec-white;

          a {
            color: $cpmec-white;
            text-decoration: none;
            font-weight: normal;
            font-size: 18px;
          }

          &.tel {
            a {
              font-weight: normal;
            }
          }

          &.has-children > ul {
            row-gap: 0;
            padding-left: 10px;
            margin-left: 10px;
            list-style: initial;

            @media (max-width: $lg) {
              list-style: none;
              padding-left: 0;
              margin-left: 0;
              text-align: center;
            }

            li {
              @media (max-width: $lg) {
                width: 100%;
              }

              &::marker {
                color: var(--cpmec-green);
              }

              a {
                @media (max-width: $lg) {
                  color: var(--cpmec-green);
                }
              }
            }
          }
        }
      }

      &.social {
        display: inline-flex;
        flex-direction: row;
        padding: 0;
        margin: 0;

        li {
          a {
            display: flex;
          }
        }
      }

      li {
        a {
          color: $cpmec-green;
          text-decoration: none;
          font-weight: normal;
          font-size: 24px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue